var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-center":"","pb-4":_vm.$vuetify.breakpoint.mdAndUp}},[_c('v-flex',{attrs:{"xs10":"","sm8":""}},[_vm._t("actions")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }